import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHomePlanSlice = createSlice({
  name: "getHomePlan",
  initialState,
  reducers: {
    getHomePlanStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHomePlanSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHomePlanFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHomePlanStart,
  getHomePlanSuccess,
  getHomePlanFailure,
  clearError,
  clearMessage,
} = getHomePlanSlice.actions;

export default getHomePlanSlice.reducer;
